export default "__VITE_ASSET__Hj6tX7ku__"